/**
 * The buyer types dates as `dd/mm/yyyy` in the new checkout, but the Core only accepts
 * `yyyy-mm-dd`: anything else is rejected with a 422, and before that validation existed
 * it was stored as is and broke the voucher rendering.
 */
const DISPLAY_DATE = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Converts `dd/mm/yyyy` to `yyyy-mm-dd`; any other value is returned untouched. */
export const formInputDateToIso = (value: string): string => {
  const match = DISPLAY_DATE.exec(value);

  return match ? `${match[3]}-${match[2]}-${match[1]}` : value;
};

/** Converts `yyyy-mm-dd` to `dd/mm/yyyy`; any other value is returned untouched. */
export const formInputDateToDisplay = (value: string): string => {
  const match = ISO_DATE.exec(value);

  return match ? `${match[3]}/${match[2]}/${match[1]}` : value;
};

/** Whether a `dd/mm/yyyy` value is a day that exists: `31/02/2020` is not. */
export const isValidFormInputDisplayDate = (value: string): boolean => {
  const match = DISPLAY_DATE.exec(value);

  if (!match) {
    return false;
  }

  const [day, month, year] = [Number(match[1]), Number(match[2]), Number(match[3])];
  const date = new Date(Date.UTC(year, month - 1, day));

  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
};
